import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { 
  Button, Typography, Box 
} from '@mui/material';
import API from '../config/axiosConfig';
import InputWithIcon from '../components/InputWithIcon';
import passwordIcon from '../assets/users/password.svg';
import { primaryButtonStyle, secondaryButtonStyle } from '../utils/sharedStyles';

function ResetPasswordConfirm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setSubmitError('קישור לא תקין או חסר');
    }
  }, [token]);

  const handleSubmit = async () => {
    setPasswordError('');
    setSubmitError('');
    if (!newPassword || newPassword.length < 6) {
      setPasswordError('סיסמה צריכה להכיל מינימום 6 תוים');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError('הסיסמאות אינן תואמות');
      return;
    }
    try {
      await API.post('/api/users/reset-password', { token, newPassword });
      setSubmitSuccess(true);
    } catch (error) {
      // The route answers with { error, hebMessage }, the global handler with
      // { error: { message, hebMessage } } — take the Hebrew text from either,
      // never data.error itself (it is English, and sometimes an object).
      const data = error.response?.data;
      setSubmitError(data?.hebMessage || data?.error?.hebMessage || 'שגיאה בשינוי הסיסמה');
    }
  };

  if (submitSuccess) {
    return (
      <Box textAlign="center" mt={4}>
        <Typography variant="h6" gutterBottom>
          הסיסמה עודכנה בהצלחה
        </Typography>
        <Button variant="contained" onClick={() => navigate('/login')} style={primaryButtonStyle}>
          התחבר
        </Button>
      </Box>
    );
  }

  return (
    <Box maxWidth={400} mx="auto" mt={4} p={2} borderRadius={2} boxShadow={3}>
      <Typography variant="h5" align="center" gutterBottom>
        שכחת את הסיסמה? ננסה לעזור!
      </Typography>
      <InputWithIcon
        icon={passwordIcon}
        placeholder="הזן סיסמה חדשה"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        autoFocus
      />
      <InputWithIcon
        icon={passwordIcon}
        placeholder="חזור שנית על הסיסמה החדשה"
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        style={{ marginTop: 20 }}
      />
      {passwordError && <Typography color="error" mt={1}>{passwordError}</Typography>}
      {submitError && <Typography color="error" mt={1}>{submitError}</Typography>}
      <Box mt={3} textAlign="center">
        <Button variant="contained" onClick={handleSubmit} style={primaryButtonStyle}>
          אישור
        </Button>
      </Box>
    </Box>
  );
}

export default ResetPasswordConfirm;